import React, { createContext, useContext, useState } from 'react';

const RoleContext = createContext({ role: null, setRole: () => {} });

export const RoleProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
